module.exports = __webpack_public_path__ + "static/media/iconFour.81eeb0b3.svg";